
export const termsAndConditionsQA = 'https://qa.morerewards.ca/legal/terms-and-conditions';
export const termsAndConditionsPROD = 'https://www.morerewards.ca/legal/terms-and-conditions';

